import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import config from '../../config';
import {fetchWorkers, fetchWorkOrderNumbers} from '../../api/employees';
import { checkOutEmployees } from '../../api/checkIn';
import { path } from 'ramda';
import Input from '../../common/Input';
import Preloader from '../../common/Preloader';
import Modal from '../../common/Modal';
import fields from './fields';
import './style.css';
import ShapedBox from '../../common/ShapedBox';
import {checkInUser} from "../../api/checkIn";
import hasAccess from "../../helpers/permissionChecker";
import ConfirmAction from "../../common/ConfirmAction";
import {changeModalState} from "../../actions/modal";

const EMPTY_USER_PHOTO_PATH = '/assets/empty-user-photo.png';

const UserTile = (props) => {
    return (
        <ShapedBox>
            <div className='text-center h-100' onClick={(e) => props.handleTileClick(props.user)}>
                <div className='text-sm text-capitalize text-truncate mt-2 mb-2 f-w-400'>{`${props.user.firstname} ${props.user.lastname}`}</div>
                <img className='user-avatar' src={props.user.picture_url ? `${config.apiEndpoint}/${props.user.picture_url}` : EMPTY_USER_PHOTO_PATH} />
                {props.user.checked_in && <i className="fa fa-check-circle color-green font-awesome-icon"></i>}
                <p>{props.user.work_order_number ? props.user.work_order_number : 'idle'}</p>
            </div>
        </ShapedBox>
    );
}

const PinPad = (props) => {
    const inputs = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X'];

    return (
        <div className='pin-pad-wrapper border'>
            {inputs.map(input => {
                return (
                    <div className='pin-pad-button border' onClick={() => props.onClick(input)} key={input}>{input}</div>
                )
            })}
        </div>
    )
}

export class CheckIn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pinNumber: '',
            selectedUser: null,
            fields: fields['search'],
            currentField: 'idle',
            workersList: []
        }

        this.pinPadClickHandler = this.pinPadClickHandler.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.checkoutEachEmployee = this.checkoutEachEmployee.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
    }

    componentDidMount() {
        this.props.workers();
        window.scrollTo(0, 0);

        this.props.workOrderNumbers()

        const workersList = path(['employees', 'workers'], this.props) || [];
        this.state.workersList = workersList.length > 0 ? workersList: [];
    }

    componentWillReceiveProps(newProps) {
      let workersList = path(['employees', 'workers'], newProps) || [];
      workersList = Object.values(workersList)

      const filteredList = workersList.length > 0 ? workersList: [];

      this.setState({
        workersList: filteredList
      })
    }

    changeFormValue(e) {
      this.setState({
        currentField: e.target.value
      })

      this.props.workers(e.target.value);
    }

    pinPadClickHandler(input) {
        if (!isNaN(input)) {
            this.setState({ pinNumber: `${this.state.pinNumber}${input}` });
        } else {
            this.setState({ pinNumber: this.state.pinNumber.substring(0, this.state.pinNumber.length - 1) });
        }
    }

    checkoutEachEmployee() {
      this.props.handleModalState({
        isOpen: !this.props.modal.isOpen,
        modalId: 'checkoutEachEmployee',
        handler: this.props.checkoutEmployees
      });
    }

    inputChangeHandler(field, newObject) {
        if (!isNaN(newObject['value'])) {
            this.setState({ pinNumber: newObject['value'].trim() });
        }
    }

    render() {
        const workOrderNumbersList = path(['employees', 'workOrderNumbers'], this.props)
        const workOrderNumbers = workOrderNumbersList ? workOrderNumbersList : []
        return (
            <div>
                <div className='card'>
                    <div className='card-header rounded-top'>JMH-ONE</div>
                    <div className='card-block'>
                        <div className="row m-0 justify-content-between align-items-center">
                            <div className='d-flex justify-content-end align-items-center mb-3'>
                              <div className='h6 ml-auto m-r-10'>Filter by Work Order:</div>
                              <div className='pin-pad-input'>
                                <select
                                  className="custom-select m-r-10"
                                  onChange={this.changeFormValue}
                                  value={this.state.currentField}>
                                  <option value="idle">idle</option>
                                  {workOrderNumbers.map((wo) => {
                                    return <option value={wo.value}>{wo.label}</option>
                                  })}
                                </select>
                              </div>
                            </div>
                            <div className='mb-3'>
                              {hasAccess({ 'permAreaKey': 'time_tracking', 'permTypeKey': 'delete' }) &&
                                <button className="btn btn-primary" onClick={this.checkoutEachEmployee}>Admin Clock Out</button>
                              }
                              <ConfirmAction
                                id={'checkoutEachEmployee'}
                                title={'Admin Clock Out'}
                                content={'Are you sure?'}
                              />
                            </div>
                          </div>
                        <div className='row m-0 justify-content-end align-items-center'>
                            <div className='h6'>Choose your profile:</div>
                            <div className='h6 ml-auto m-r-10'>Or enter your PIN:</div>
                            <div className='pin-pad-input'>
                                <Input
                                    ref={this.inputRef}
                                    field={{ ...this.state.fields, value: this.state.pinNumber }}
                                    onChange={this.inputChangeHandler}
                                />
                                <PinPad onClick={this.pinPadClickHandler} />
                            </div>
                        </div>
                        {!this.state.workersList ?
                            <Preloader
                                show={true}
                                type={'circle'}
                            /> :
                            <div className='row m-0 d-flex flex-wrap justify-content-start list-users'>
                                {this.state.workersList && this.state.workersList.length ? this.state.workersList.map((user, index) => {
                                    return (
                                        <UserTile
                                            key={user.id}
                                            user={user}
                                            handleTileClick={(selectedUser) => this.setState({ selectedUser })}
                                        />
                                    )
                                }) : <div className='m-auto p-50 text-center'>No user found with given PIN. Please try different one.</div>}
                            </div>
                        }
                        {!!this.state.selectedUser &&
                            <Modal
                                id={'ConfirmSelecedUser'}
                                show={!!this.state.selectedUser}
                                title={`${this.state.selectedUser.firstname} is that you?`}
                                content={<img className='user-avatar user-avatar-modal' src={this.state.selectedUser.picture_url ? `${config.apiEndpoint}/${this.state.selectedUser.picture_url}` : EMPTY_USER_PHOTO_PATH} />}
                                secondary={'Back'}
                                primary={'Confirm'}
                                cancelHandler={() => this.setState({ selectedUser: null })}
                                confirm={() => this.props.moveToUserCheckin(this.state.selectedUser.id)}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleModalState: (data) => {
          dispatch(changeModalState(data));
        },
        workers: (workOrderNumber = '') => {
            fetchWorkers(workOrderNumber)(dispatch);
        },
        workOrderNumbers: () => {
            fetchWorkOrderNumbers()(dispatch)
        },
        moveToUserCheckin: (userid) => {
            checkInUser(userid)(dispatch);
            dispatch(push(`/pages/check-in/${userid}`));
        },
        checkoutEmployees: () => {
            checkOutEmployees()(dispatch)
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckIn);



// WEBPACK FOOTER //
// ./src/containers/CheckIn/index.js